import _ from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';
import ContactStyles from './ContactStyles.scss';
import PhoneUtils from '../../../lib/utils/phone';
import LocationUtils from '../../../lib/utils/location';
import { Divider, Icon } from 'semantic-ui-react';
import ContactShow from './ContactShow';
import ContactFields from './ContactFields';

export default class ContactEditDesktop extends React.Component {
  static propTypes = {
    avatarCache: PropTypes.object.isRequired,
    updateAvatarCache: PropTypes.func.isRequired,
    contact: PropTypes.object.isRequired,
    localContact: PropTypes.object.isRequired,
    commitUpdate: PropTypes.func.isRequired,
    onChange: PropTypes.func.isRequired,
    index: PropTypes.number,
    role: PropTypes.string,
    localRole: PropTypes.string,
    reset: PropTypes.func,
    delete: PropTypes.func,
    roleChangeHandler: PropTypes.func.isRequired,
    closeEditor: PropTypes.func,
    isNew: PropTypes.bool,
    initiallyOpen: PropTypes.bool,
    deleteUserContactEmail: PropTypes.func.isRequired,
    deleteUserContactPhone: PropTypes.func.isRequired,
    deleteUserContactAddress: PropTypes.func.isRequired
  };

  constructor(props) {
    super(props);
    this.state = {
      editing: this.props.initiallyOpen
    };
    this.toggleEditing = this.toggleEditing.bind(this);
  }

  componentDidMount() {
    // if (this.refs.contact.node.scrollIntoViewIfNeeded) this.refs.contact.node.scrollIntoViewIfNeeded();
  }

  componentWillUnmount() {
    if (this.props.closeEditor) this.props.closeEditor();
  }

  toggleEditing() {
    this.setState({ editing: !this.state.editing });
  }

  render() {
    const contact = this.props.contact;

    return (
      <div className={ContactStyles.active}>
        {!this.state.editing &&
          <div>
            <a
              className={ContactStyles.editButton}
              onClick={this.toggleEditing}
            >
              Edit
            </a>
            <ContactShow
              contact={contact}
              avatarCache={this.props.avatarCache}
              updateAvatarCache={this.props.updateAvatarCache}
              extended
            />
            <div
              className={
                contact.node.user_contact_phones.edges.length > 0
                  ? ContactStyles.section
                  : ''
              }
            >
              {contact.node.user_contact_phones.edges.map(
                (userContactPhone, idx) => {
                  const number = userContactPhone.node.number;
                  return (
                    <div style={{ display: 'flex' }} key={idx}>
                      {contact.node.user_contact_phones.edges.length > 0 &&
                        <div className={ContactStyles.type}>
                          <Icon name='phone' />
                        </div>}
                      <span
                        key={userContactPhone.node.id || idx}
                        className={ContactStyles.expanding}
                      >
                        <a href={`tel:${number}`}>
                          {PhoneUtils.formatPhoneNumber(number)}
                        </a>
                        <div className={ContactStyles.label}>
                          {_.capitalize(userContactPhone.node.label)}
                        </div>
                        {idx ===
                          contact.node.user_contact_phones.edges.length - 1 &&
                          (contact.node.user_contact_emails.edges.length > 0 ||
                            contact.node.user_contact_addresses.edges.length >
                              0) &&
                          <Divider className={ContactStyles.divider} />}
                      </span>
                    </div>
                  );
                }
              )}
            </div>
            <div
              className={
                contact.node.user_contact_emails.edges.length > 0
                  ? ContactStyles.section
                  : ''
              }
            >
              {contact.node.user_contact_emails.edges.map(
                (userContactEmail, idx) =>
                  <div style={{ display: 'flex' }} key={idx}>
                    {contact.node.user_contact_emails.edges.length > 0 &&
                      <div className={ContactStyles.type}>
                        <Icon name='envelope' />
                      </div>}
                    <span
                      key={userContactEmail.node.id || idx}
                      className={ContactStyles.expanding}
                    >
                      <a
                        onClick={e => e.stopPropagation()}
                        href={`mailto:${userContactEmail.node.address}`}
                      >
                        {userContactEmail.node.address}
                      </a>
                      <div className={ContactStyles.label}>
                        {_.capitalize(userContactEmail.node.label)}
                      </div>
                      {idx ===
                        contact.node.user_contact_emails.edges.length - 1 &&
                        contact.node.user_contact_addresses.edges.length > 0 &&
                        <Divider className={ContactStyles.divider} />}
                    </span>
                  </div>
              )}
            </div>
            <div
              className={
                contact.node.user_contact_addresses.edges.length > 0
                  ? ContactStyles.section
                  : ''
              }
            >
              {contact.node.user_contact_addresses.edges.map(
                (userContactAddress, idx) =>
                  <div style={{ display: 'flex' }} key={idx}>
                    {contact.node.user_contact_addresses.edges.length > 0 &&
                      <div className={ContactStyles.type}>
                        <Icon name='map marker alternate' />
                      </div>}
                    <div
                      key={userContactAddress.node.id || idx}
                      className={ContactStyles.expanding}
                    >
                      {userContactAddress.node.line1 &&
                        <div>
                          {userContactAddress.node.line1}
                        </div>}
                      {userContactAddress.node.line2 &&
                        <div>
                          {userContactAddress.node.line2}
                        </div>}
                      <div>
                        {LocationUtils.getLocalityString({
                          city: userContactAddress.node.city,
                          province: userContactAddress.node.province,
                          postal_code: userContactAddress.node.postal_code
                        })}
                      </div>
                      <div className={ContactStyles.label}>
                        {_.capitalize(userContactAddress.node.label)}
                      </div>
                    </div>
                  </div>
              )}
            </div>
          </div>}
        {this.state.editing &&
          <div style={{ padding: '2em 3em' }}>
            <ContactFields
              deleteUserContactEmail={this.props.deleteUserContactEmail}
              deleteUserContactPhone={this.props.deleteUserContactPhone}
              deleteUserContactAddress={this.props.deleteUserContactAddress}
              delete={this.props.delete}
              reset={this.props.reset}
              commitUpdate={this.props.commitUpdate}
              onChange={this.props.onChange}
              contact={this.props.contact}
              localContact={this.props.localContact}
              index={this.props.index}
              closeHandler={this.toggleEditing}
            />
          </div>}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./webpack/components/Event/Show/ContactEditDesktop.js